<template>
  <div class="manans-ip">
    <cq-header headertext="MANAN'S IP"></cq-header>

    <cqtextimagesection direction = "R" :imagesrc="images.manansip">
        
        <cq-paratext> Manan started the Gain Movement primarily <b class="red"> to solve the Implementation problem. </b> </cq-paratext>
        <cq-paratext> Many people have a lot of knowledge and awareness but when interviewed by Manan they say, <b class="red"> "I am still not as successful as I know I am naturally capable of." </b> </cq-paratext>
        <cq-paratext> Many realized that <b class="red"> 'gyaan' </b> alone is not enough to produce results. Thus driven by the need for <b class="red"> Implementation, </b> Manan is dedicated to inventing and updating a set of fool-proof implementation tools and formats after observing, studying, and learning the flaws and failings of others. </cq-paratext>
        <cq-paratext> His own Colloquium System has been updated by him 7 times in the last 5 years. </cq-paratext>
        
    </cqtextimagesection>
  </div>
</template>

<script>
import CQHeader from '../../components/ui/CQHeader.vue'
import CQPara from '../../components/ui/CQPara.vue'
import CQTextImageSection from '../../components/ui/CQTextImageSection.vue'

// Import Image
import manansip from '../../assets/image/mv/manansip.png'

export default {
    components:{
        'cq-header' : CQHeader,
        'cq-paratext' : CQPara,
        'cqtextimagesection': CQTextImageSection,
    },
    data() {
    return {
        images: { 
            manansip,
        }
    }
  }

}
</script>

<style scoped>
  .manans-ip >>> .red{
    color: var(--primary-color);
  }

  .manans-ip >>> .tgg-img{
    padding-top: 0 !important;
    margin-bottom: 12px;
    z-index: 1;
  }

  .manans-ip >>> .behind-header{
    margin-bottom: 0 !important;
    z-index: 3;
  }

  /* Desktop View */
@media only screen and (min-width: 992px){
  .manans-ip >>> .gg1{
    /* padding-left: 10px !important; */
    text-align: center;
  }

  .manans-ip >>> .tgg-img{
    /* margin-top: -25px; */
    max-width: 75%;
    margin-bottom: 30px;
    padding: 0 !important;
  }

  .manans-ip >>> .gg2 {
    padding-top: 10%;
    padding-right: 104.5px !important;
  }
}

/* Mobile View */
@media only screen and (max-width: 992px){
  .manans-ip >>> .red{
    font-size: 18px !important;
  }

  .manans-ip >>> .tgg-img{
    padding-bottom: 5%;
  }
}
</style>